import FocusTrap from 'focus-trap-react';
import React, { CSSProperties } from 'react';
import { CSSTransition } from 'react-transition-group';

import HoverIcon from 'components/HoverIcon';
import { Container } from '../../custom/styles';
import {
  HeaderText,
  ModalBody,
  ModalContainer,
  ModalHeader,
  ModalHeaderInfo,
  ModalMain,
  TabItem,
  TabsList,
} from './styles';
import LocalIcon from '../../ui/LocalIcon';

const transitionName = 'modal';

interface ITabProps {
  id: number | string;
  title: string;
}

export interface IModalProps {
  tabs?: ITabProps[];
  sideElements?: React.ReactNode;
  title: string;
  width?: string;
  height?: string;
  onClose: () => void;
  isActive?: boolean;
  selectedTab?: number | string;
  onSelectATab?: (tabId: number | string) => void;
  simpleModal?: boolean;
  withoutHeader?: boolean;
  mainStyle?: CSSProperties | undefined;
  bodyStyle?: CSSProperties | undefined;
  showHome?: boolean;
  isAlert?: boolean;
  children?: React.ReactNode;
}

class Modal extends React.PureComponent<IModalProps> {
  handleCloseModal = () => {
    this.props.onClose();
  };

  handleSelectATab = (tabId: number | string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (this.props.onSelectATab) {
      this.props.onSelectATab(tabId);
    }
  };

  onKeyDown = (event: React.KeyboardEvent) => {
    if (event.keyCode === 27) {
      this.props.onClose();
    }
  };

  render() {
    const {
      tabs,
      title,
      width,
      height,
      children,
      isActive,
      selectedTab,
      showHome,
      isAlert,
      sideElements,
    } = this.props;
    return (
      <CSSTransition
        in={isActive}
        timeout={200}
        classNames={transitionName}
        unmountOnExit={true}
      >
        <ModalContainer
          tabIndex={-1}
          onKeyDown={this.onKeyDown}
          isAlert={isAlert}
        >
          <FocusTrap focusTrapOptions={{ clickOutsideDeactivates: true }}>
            {this.props.simpleModal ? (
              <Container>{children}</Container>
            ) : (
              <ModalMain
                width={width}
                height={height}
                style={this.props.mainStyle ?? {}}
                isAlert={isAlert}
              >
                {!this.props.withoutHeader && !isAlert ? (
                  <ModalHeader hasTab={!!tabs}>
                    <ModalHeaderInfo>
                      <LocalIcon
                        iconName="close-square.svg"
                        isLink={true}
                        color="no-color"
                        type="sm"
                        onClick={this.handleCloseModal}
                        style={{
                          margin: 'auto !important',
                          width: '2.5rem !important',
                        }}
                      />
                      {showHome && (
                        <HoverIcon
                          type="home"
                          color="red"
                          onClick={() => (window.location.href = '/homepage')}
                          tabIndex={0}
                        />
                      )}
                      <HeaderText>{title}</HeaderText>
                    </ModalHeaderInfo>

                    {tabs ? (
                      <TabsList>
                        {tabs.map((tab) => (
                          <TabItem
                            onClick={
                              tab.id !== selectedTab
                                ? this.handleSelectATab(tab.id)
                                : undefined
                            }
                            active={tab.id === selectedTab}
                            key={tab.id}
                          >
                            {tab.title}
                          </TabItem>
                        ))}
                        <div style={{ flexGrow: 1 }} />
                        {sideElements}
                      </TabsList>
                    ) : (
                      sideElements
                    )}
                  </ModalHeader>
                ) : null}
                <ModalBody
                  style={this.props.bodyStyle ?? {}}
                  tabIndex={1}
                  isAlert={isAlert}
                >
                  {children}
                </ModalBody>
              </ModalMain>
            )}
          </FocusTrap>
        </ModalContainer>
      </CSSTransition>
    );
  }
}

export default Modal;
